import React, { Fragment, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../actions/auth';


const Navbar = ({ logout, auth }) => {
    const [redirect, setRedirect] = useState(false);
    const [search, setSearch] = useState("");

    const logout_user = () => {
        logout();
        setRedirect(true);
    };

    const guestLinks = () => (
        <Fragment>
            <li>
                <Link className='nav-link ml-1 px-3' to='/login'>Login</Link>
            </li>
            <li>
                <Link className='nav-link ml-1 px-3' to='/signup'>Sign Up</Link>
            </li>
        </Fragment>
    );

    const authLinks = () => (
        <Fragment>
            <li>
                <Link className='nav-link ml-1 px-3' to='/' ><a  href='#!' onClick={logout_user}>Logout</a></Link>
            </li>
        </Fragment>
        
    );

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    return (
        <Fragment>
        <nav className='navbar navbar-expand-lg navbar-dark w3-black fixed-top' style={{height:'60px'}} >
                <Link className='navbar-brand' to='/'> <img src="/images/header-logo.jpg"  alt="..." style={{height:'45px'}} /></Link>
                <div className='collapse navbar-collapse' id='navbarNavDropdown'>
                    <ul className='navbar-nav'>
                        <li>
                            <Link className='nav-link ml-1 px-3' to='/'>Home <span className='sr-only'>(current)</span></Link>
                        </li>
                        {auth.isAuthenticated ? authLinks() : guestLinks()}
                        <li>
                            <Link className='nav-link ml-1 px-3' to='/about'>About Us <span className='sr-only'></span></Link>
                        </li>
                        <li>
                            <Link className='nav-link ml-1 px-3' to='/contact'>Contact Us <span className='sr-only'></span></Link>
                        </li>
                        <li>
                            <Link className='nav-link ml-1 px-3' to='/calculator'>Calculator <span className='sr-only'></span></Link>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link ml-1 px-3 dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Store</a>
                            <div className="dropdown-menu bg-dark" aria-labelledby="navbarDropdown">
                                <Link className='nav-link ml-1 px-3' to='/store-services'>Services <span className='sr-only'></span></Link>
                                <Link className='nav-link ml-1 px-3' to='/store-prodcuts'>Products <span className='sr-only'></span></Link>
                            </div>
                        </li>
                    </ul>
                    <div className="form-inline my-2 ml-2">
                        <input onChange={handleSearch}
                            type='text' name='search' className="search-click bg-dark text-white" />
                        </div>
                        <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/searched', 
                                    state:{search:search}
                                }}>
                        <button type="button" className="btn text-white bg-dark" style={{height: '36px', border: 'none', borderBottom: '2px solid #ccc', borderRadius: '0px'}}>
                            <i className="fa fa-search" style={{height: '34px'}}></i>
                        </button>
                        </Link>
                    </div>
                
                <div className='row' style={{textAlign : 'right',color:'white'}}>
                <div className='col mt-2'>
                    <strong>
                    {auth.user ? ` ${auth.user.first_name.toUpperCase()}` : ''}
                    </strong>
                </div>
                <div className='col'>
                    {auth.user ? 
                        <div className="dropstart">
                            <button className="btn btn-primary" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="fa fa-bars"></i>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" style={{backgroundColor:'black'}}>
                            {auth.user.is_staff ? <li><button type="button" className="btn btn-dark" style={{fontSize:'14px', borderRadius:0,width:'100%'}}><Link  to='/categories' style={{ textDecoration: 'none' }}>Admin Menu</Link></button></li>:null}
                                <li><button type="button" className="btn btn-dark" style={{fontSize:'14px', borderRadius:0, width:'100%'}}><Link  to='/SellerDashboard'  style={{ textDecoration: 'none' }} >Seller Dashboard</Link></button></li>
                                <li><button type="button" className="btn btn-dark" style={{fontSize:'14px', borderRadius:0,width:'100%'}}><Link  to='/BuyerDashboard' style={{ textDecoration: 'none' }}>Buyer Dashboard</Link></button></li>
                                <li><button type="button" className="btn btn-dark" style={{fontSize:'14px', borderRadius:0,width:'100%'}}><Link  to='/cart' style={{ textDecoration: 'none' }}>My Cart</Link></button></li>
                                
                            </ul>
                        </div>
                     : ''}
                </div>
                </div>
            </nav>
            {redirect ? <Redirect to='/' /> : <Fragment></Fragment>}
        </Fragment>
    );
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, { logout })(Navbar);
